// Utility functions to transform lookup API responses to match existing interfaces

import { Lead } from '../leads/lead.service';
import { Deal } from '../deals/deal.service';
import { Pipeline } from '../pipeline/pipeline.service';

export const transformLookupLeadToLead = (lookupData: any): Lead => {
  return {
    lead_id: lookupData.lead_id,
    crm_entity_id: lookupData.crm_entity_id,
    title: lookupData.title,
    source: lookupData.source,
    lifecycle_source_id: lookupData.lifecycle_source_id || lookupData.lifecycle_source?.lifecycle_source_id || null,
    lifecycle_source: lookupData.lifecycle_source,
    score: lookupData.score,
    preferred_language: lookupData.preferred_language,
    time_zone: lookupData.time_zone,
    created_datetime: lookupData.created_datetime,
    updated_datetime: lookupData.updated_datetime,
    created_by: lookupData.created_by,
    updated_by: lookupData.updated_by,
    assigned_user_id: lookupData.assigned_user?.user_id || null,
    assigned_datetime: lookupData.assigned_datetime,
    estimated_value: lookupData.estimated_value,
    currency_code: lookupData.currency_code,
    priority: lookupData.priority,
    products_n_services: lookupData.products_n_services,
    primary_contact: lookupData.primary_contact,
    company_id: lookupData.company?.company_id || null,
    company: lookupData.company,
    assigned_user: lookupData.assigned_user,
    lifecycle_type_stage: lookupData.current_stage,
    tenant_id: lookupData.tenant?.tenant_id || null,
    assigned_team: lookupData.assigned_team || null,
    tags: lookupData.tags || {
      insert: [{
        entity_tag_id: 0,
        entity_tag_name: ""
      }]
    },
    is_archive: lookupData.is_archive || false,
    is_active: lookupData.is_active ?? null,
    lifecycle_status_reason: lookupData.lifecycle_status_reason || null,
    ...(lookupData.custom_fields && { custom_fields: lookupData.custom_fields }),
    ...(lookupData.product_n_service && { product_n_service: lookupData.product_n_service })
  };
};

export const transformLookupDealToDeal = (lookupData: any): Deal => {
  return {
    deal_id: lookupData.deal_id,
    crm_entity_id: lookupData.crm_entity_id,
    title: lookupData.title,
    source: lookupData.source,
    lifecycle_source_id: lookupData.lifecycle_source_id || lookupData.lifecycle_source?.lifecycle_source_id || null,
    lifecycle_source: lookupData.lifecycle_source,
    exepected_amount: lookupData.exepected_amount,
    estimated_value: lookupData.estimated_value,
    grand_total: lookupData.grand_total,
    currency_code: lookupData.currency_code,
    priority: lookupData.priority,
    products_n_services: lookupData.products_n_services,
    created_datetime: lookupData.created_datetime,
    updated_datetime: lookupData.updated_datetime,
    created_by: lookupData.created_by,
    updated_by: lookupData.updated_by,
    assigned_user_id: lookupData.assigned_user?.user_id || null,
    assigned_datetime: lookupData.assigned_datetime,
    primary_contact: lookupData.primary_contact,
    company_id: lookupData.company?.company_id || null,
    company: lookupData.company,
    assigned_user: lookupData.assigned_user,
    lifecycle_type_stage: lookupData.current_stage,
    tenant_id: lookupData.tenant?.tenant_id || null,
    realted_lead: lookupData.realted_lead,
    related_pipeline: lookupData.related_pipeline,
    assigned_team: lookupData.assigned_team || null,
    lifecycle_status_reason: lookupData.lifecycle_status_reason || null,
    is_archive: lookupData.is_archive || false,
    tags: lookupData.tags || {
      insert: [{
        entity_tag_id: 0,
        entity_tag_name: ""
      }]
    },
    ...(lookupData.custom_fields && { custom_fields: lookupData.custom_fields }),
    ...(lookupData.product_n_service && { product_n_service: lookupData.product_n_service })
  };
};

export const transformLookupPipelineToPipeline = (lookupData: any): Pipeline => {
  const pipeline: any = {
    pipeline_id: lookupData.pipeline_id,
    crm_entity_id: lookupData.crm_entity_id,
    created_by_username: lookupData.created_by_username,
    updated_by_username: lookupData.updated_by_username,
    title: lookupData.title,
    priority: lookupData.priority,
    products_n_services: lookupData.products_n_services,
    estimated_value: lookupData.estimated_value,
    currency_code: lookupData.currency_code,
    source: lookupData.source,
    lifecycle_source_id: lookupData.lifecycle_source_id || lookupData.lifecycle_source?.lifecycle_source_id || null,
    lifecycle_source: lookupData.lifecycle_source,
    created_datetime: lookupData.created_datetime,
    updated_datetime: lookupData.updated_datetime,
    assigned_datetime: lookupData.assigned_datetime,
    created_by: lookupData.created_by,
    updated_by: lookupData.updated_by,
    primary_contact: lookupData.primary_contact,
    company: lookupData.company,
    assigned_user: lookupData.assigned_user,
    lifecycle_type_stage: lookupData.current_stage,
    tenant: lookupData.tenant,
    realted_lead: lookupData.realted_lead,
    assigned_team: lookupData.assigned_team || null,
    product_n_service: lookupData.product_n_service || [],
    is_archive: lookupData.is_archive || false,
    lifecycle_status_reason: lookupData.lifecycle_status_reason || null,
    tags: lookupData.tags || {
      insert: [{
        entity_tag_id: 0,
        entity_tag_name: ""
      }]
    },
  };

  if (
    lookupData.product_n_service &&
    Array.isArray(lookupData.product_n_service) &&
    lookupData.product_n_service.length > 0
  ) {
    pipeline.products_n_services = lookupData.product_n_service
      .map((item: any) => item.product_n_service_name || "Unknown Product")
      .join(", ");
  }

  if (lookupData.custom_fields) {
    pipeline.custom_fields = lookupData.custom_fields;
  }

  return pipeline;
};
